if (!customElements.get('aurrelle-empty-cart')) {
  customElements.define('aurrelle-empty-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('[type="submit"]');
        if (button.disabled) return;
        button.disabled = true;
        const status = this.querySelector('[data-empty-cart-status]');
        status.textContent = '';
        try {
          const preview = this.querySelector('aurrelle-discount-preview');
          await customElements.whenDefined('aurrelle-discount-preview');
          if (preview.input.value.trim() && !preview.dataset.code) await preview.apply();
          const code = await preview.checkoutCode();
          if (preview.input.value.trim() && !code) { preview.input.focus(); return; }
          const addUrl = new URL(form.action);
          addUrl.pathname += '.js';
          const response = await fetch(addUrl, {
            method: 'POST', body: new FormData(form),
            headers: {Accept: 'application/json'}
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          const destination = this.dataset.cartUrl;
          if (code) {
            await fetch(destination + '/update.js', {
              method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
              body: JSON.stringify({discount: code})
            });
          }
          window.location.assign(destination);
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}
